const OPERATOR_MENU_NAMES = new Set(['Inbox', 'Conversation', 'Contacts']);

export const filterSidebarMenuItems = (items, policy) => {
  if (policy.isAdmin || !policy.isSynchronizedEmployee) return items;

  return items.filter(item => OPERATOR_MENU_NAMES.has(item.name));
};

export const profileIdentifier = user =>
  user.custom_attributes?.smp_login || user.email;
